import { oz } from '@weft/utils';
import { ApiDateSchema, ObjectIdSchema } from '../../primitives';

export const IngestionCustomerSchema = oz.object({
  customerId: ObjectIdSchema,
  customerName: oz.string().min(1),
  createdAt: ApiDateSchema,
});

export type IngestionCustomer = oz.infer<typeof IngestionCustomerSchema>;